import { createDomainStore } from '../../storage/create-domain-store';
import { DomainStoreType } from '../../storage/types/domain-store';
import { defaultOrderDomainState } from './state';
/**
 * The single instance of the orderDomainStore.
 *
 * Order data is explicitly stored in sessionStorage instead of localStorage to
 * ensure that an in-progress order isn't modified/cancelled between tabs.
 */
export const orderDomainStore = createDomainStore({
    type: DomainStoreType.BrowserSession,
    defaultState: defaultOrderDomainState,
    name: 'order-domain-store'
});
//# sourceMappingURL=store.js.map